import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getCookie } from 'cookies-next';
import { trackEvent } from 'integrations/metrics';
import { EventNames } from 'integrations/metrics/events';
import { EventAction, EventObjectType } from 'integrations/metrics/types';
import { getBookingFlowType } from 'selectors/services';

import { useAppContext } from 'hooks/context/useAppContext';
import { useGGTheme } from 'hooks/theme/useGGTheme';

import { ServicesError } from './ServicesError/ServicesError';

const GENIUS_AI_SOURCE_KEY = 'geniusAiSource';

export function ServicesContainer() {
  const {
    components: { Layout },
    pages: { Services },
  } = useGGTheme();

  const { publicUser } = useAppContext();

  const bookingFlowType = useSelector(getBookingFlowType);

  useEffect(() => {
    const isInIframe = window.self !== window.top;
    const geniusAiSource = getCookie(GENIUS_AI_SOURCE_KEY) === 'true';

    trackEvent(EventNames.CLIENT_ENTERED_BOOKING_FLOW, {
      action: EventAction.SELECT,
      productSection: 'Booking',
      productSubSection: 'Services',
      objectType: EventObjectType.PAGE,
      bookingFlowType: bookingFlowType,
      isIframeEmbed: isInIframe,
      geniusAiSource: geniusAiSource,
    });
  }, [bookingFlowType]);

  return (
    <Layout>
      {publicUser.services_error ? <ServicesError /> : <Services />}
    </Layout>
  );
}
